import { TemperatureClass } from '../enums';

export const DEFAULT_TEMPERATURE_CLASS = TemperatureClass.HeatingTimeT3;
